









































































































import { useTracking } from '@a/plugins/tracking';
import { TrackingEventTypes } from '@a/plugins/tracking/types/tracking';
import { useStore } from '@a/store';
import {
  computed,
  defineComponent, getCurrentInstance, onMounted, onUnmounted,
} from '@vue/composition-api';
import { useI18N } from '../../composables/use-vue-i18n';
import { useConfigurationApi } from '../../plugins/configuration';
import { ActiveOrderConfiguration, LandingPageItem } from '../../store/landingpage/types';
import { useScrollBehaviour } from './OrderNowBarFeatures';
import OrderNowButton from './OrderNowButton.vue';

export default defineComponent({
  components: { OrderNowButton },
  name: 'OrderNowBar',
  setup() {
    const i18n = useI18N();
    const { data } = useConfigurationApi();
    const tracking = useTracking();
    const store = useStore();
    const landingPageData = data.pageData as LandingPageItem;
    // using composition style template refs does not work in mounting portal,
    // so we have to use instance instead 😐
    const instance = getCurrentInstance();

    const { isSticky, initScrollBehaviour, destroyScrollBehaviour } = useScrollBehaviour(instance);

    const activeOrderConfiguration = computed<ActiveOrderConfiguration>(() => store.getters['landingPage/activeOrderConfiguration']);

    const trackOrder = () => {
      tracking.track({
        event: TrackingEventTypes.LP_BTN_ORDER_NOW,
        data: {
          type: 'button',
          target: landingPageData.orderUrl,
          productKey: landingPageData.key,
        },
      });
    };

    onMounted(initScrollBehaviour);

    onUnmounted(destroyScrollBehaviour);

    return {
      i18n,
      landingPageData,
      isSticky,
      activeOrderConfiguration,
      trackOrder,
    };
  },
});
